import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';
import { link, SanityLink } from './link';

export const SanityHomepageContentCards = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('homepageContentCards'),
  _key: z.string().optional(),
  eyebrow: z.string().optional().nullable(),
  headline: z.string(),
  theme: z
    .enum(['purple', 'gray', 'black', 'light', 'charcoal'])
    .optional()
    .nullable(),
  background: z.enum(['gradient', 'none']).optional().nullable(),
  link: SanityLink.optional().nullable(),
  items: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      href: z.string(),
      image: SanityImage,
      excerpt: z.string(),
      buttonText: z.string().optional().nullable(),
    }),
  ),
});
export type SanityHomepageContentCards = z.infer<
  typeof SanityHomepageContentCards
>;

export const homepageContentCards = groq`{
  _type,
  eyebrow,
  headline,
  "theme": select(
    theme == "gray" => "light",
    theme == "black" => "charcoal",
    coalesce(theme, "purple")
  ),
  background,
  link[0] ${link},
  items[] {
    _key,
    title,
    buttonText,
    'href': select(
      reference->_type == 'post' => '/blog/' + reference->slug.current,
      reference->_type == 'resource' => '/resources/' + reference->slug.current,
      '/case-studies/' + reference->slug.current
    ),
    'title': coalesce(title, reference->title),
    'excerpt': coalesce(description, reference->excerpt),
    'image': coalesce(image ${image}, reference->featuredImage ${image}, reference->thumbnailImage ${image}),
  },
}`;
